import { useEffect, useLayoutEffect, useRef } from 'react';
import { createScanBuffer, isEditableTarget, normalizeScannedCode } from './barcodeScan';

// Nasłuch czytnika na całej stronie (2026-09-23).
//
// Czytnik USB/Bluetooth jest dla przeglądarki klawiaturą, więc nie ma czego „podłączać"
// — wystarczy słuchać klawiatury i rozpoznać tempo (patrz `barcodeScan.js`).
//
// Nasłuch CELOWO odpuszcza zdarzenia wychodzące z pól tekstowych: gdy kursor stoi w polu,
// czytnik wpisuje kod dokładnie tam, gdzie człowiek go postawił. Przekierowywanie go gdzie
// indziej wymagałoby wycofywania znaków już wstawionych do pola — a to widać na ekranie
// jako miganie tekstu i psuje najprostszy przypadek („kliknąłem w pole kodu i skanuję").
//
// `onScan` trzymamy w ref, żeby nasłuch rejestrował się RAZ, a nie przy każdym renderze
// strony przekazującej strzałkę inline (a takie są wszystkie wołające).
export default function useBarcodeScan(onScan, { enabled = true, maxPrzerwaMs, minDlugosc } = {}) {
  const onScanRef = useRef(onScan);

  // useLayoutEffect, nie useEffect: zwykły efekt React potrafi odpalić PO pokazaniu nowego
  // stanu, więc drugi skan tuż po pierwszym (telefon strumieniujący kody, szybki czytnik)
  // trafiał do poprzedniego `onScan` ze starymi danymi — np. wydanie zapisywało się dwa razy.
  useLayoutEffect(() => { onScanRef.current = onScan; }, [onScan]);

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;

    const bufor = createScanBuffer({ maxPrzerwaMs, minDlugosc });

    const obsluz = (e) => {
      if (isEditableTarget(e.target)) { bufor.reset(); return; }
      const kod = normalizeScannedCode(bufor.push(e, Date.now()));
      if (!kod) return;
      // Enter kończący skan nie może trafić dalej: na stronie z formularzem wysłałby go,
      // a na liście — uruchomił domyślną akcję przycisku, na którym akurat stoi fokus.
      e.preventDefault();
      const fn = onScanRef.current;
      if (typeof fn === 'function') fn(kod);
    };

    document.addEventListener('keydown', obsluz);
    return () => document.removeEventListener('keydown', obsluz);
  }, [enabled, maxPrzerwaMs, minDlugosc]);
}
